
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { IconName } from "@/lib/icons/icons";

@Component({
  components: { Icon }
})
export default class NiceButton extends Vue {
  @Prop({
    default: "default"
  })
  size!: string;

  @Prop()
  disabled?: boolean;

  @Prop()
  expanded?: boolean;

  @Prop()
  leftIcon?: IconName;

  @Prop()
  rightIcon?: IconName;

  @Prop({
    default: false
  })
  loading!: boolean;

  @Prop({
    default: "secondary"
  })
  color!: string;

  @Prop()
  href?: string;

  get tag() {
    return this.href ? "a" : "button";
  }

  get classes() {
    return {
      [`breakdance-nice-button--${this.size}`]: true,
      [`breakdance-nice-button--${this.color}`]: true,
      "breakdance-nice-button--loading": this.loading,
      "breakdance-nice-button--disabled": this.disabled,
      "breakdance-nice-button--expanded": this.expanded
    };
  }

  get iconSize() {
    if (this.size === "x-small") return 10;
    if (this.size === "small") return 14;
    return 16;
  }
}
